import React, { useEffect, useState } from "react"
import SEO from "../components/seo"
import NewLayout from "../layout/newLayout"
import styles from "../styles/scss/templates/industrial-page-new.module.scss"
import CardDeck from "../components/industrial/card-deck"
import FullWidthCTA from "../components/industrial/FullWidthCTA"
import NumberedStepsList from "../components/industrial/NumberedStepsList"
import SiteAssessmentForm from "../components/industrial/SiteAssessmentForm"
import VideoSection from "../components/industrial/VideoSection"
import Hero from "../components/industrial/Hero"
import AdBlock from "../components/adBlock";
import { industrialPageDataNew } from "../components/industrial/industrialPageDataNew"
import { foodAndBeverageData } from "../components/industrial/foodAndBeverageData"
import { heavyManufacturingData } from "../components/industrial/heavyManufacturingData"
import { metalFabricationData } from "../components/industrial/metalFabricationData"
import { oilAndGasData } from "../components/industrial/oilAndGasData"
import { transportationData } from "../components/industrial/transportationData"


const IndustrialPageNew = (props) => {
    // Page Context
    const pageData = props.pageContext.page;
    //check for mobile widths
    const [isMobile, setIsMobile] = useState(false)
    
    const pageSlug = (pageData && pageData.slug) ? pageData.slug : "";
    const adBlocks = pageData && pageData.adBlocks ? pageData.adBlocks : [];

    const pageSpecificData = {
        "food-and-beverage": foodAndBeverageData,
        "heavy-manufacturing": heavyManufacturingData,
        "metal-fabrication": metalFabricationData,
        "oil-and-gas": oilAndGasData,
        "transportation": transportationData,
    }[pageSlug] || industrialPageDataNew;
    
    const handleResize = function() {
        if (typeof window !== "undefined") {
            if (window.innerWidth <= 576) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        }
    };

    useEffect(function() {
        if (typeof window !== "undefined") {
            window.addEventListener("resize", handleResize);
            handleResize();

            return function() {
                window.removeEventListener("resize", handleResize);
            };
        }
        return undefined;
    }, []);

    const heroSectionContent = {
        title: pageData.heroTitle || pageData.title,
        eyebrow: pageData.eyebrow || '',
        body: pageData.heroBody || '',
        heroMobile: pageData.heroMobile,
        heroDesktop: pageData.heroDesktop
    }
    const scrollToSection = function(e, sectionId) {
        e.preventDefault();
        e.stopPropagation();
        const element = typeof window !== "undefined" ? window.document.getElementById(sectionId) : null;
        if (element) {
            element.scrollIntoView({ block: "center", behavior: "smooth" });
        }
    };
   
    return (
        <NewLayout>
            <SEO page={pageData} />
            <div className={styles.industrialWrapper}>
                
                <Hero 
                    heroSectionContent={heroSectionContent}
                    breadcrumbs={pageSpecificData.breadcrumbs}
                    heroCTAs={pageSpecificData.heroCTAs}
                    themeColor={pageSpecificData.themeColor}
                    pageSlug={pageSlug}
                    heroStyles={pageSpecificData.heroStyles}
                />

                <AdBlock data={adBlocks} />
                
                {pageSpecificData.components && pageSpecificData.components.map((componentData, index) => {
                    switch(componentData.component) {
                        case 'cardDeck':
                            if (componentData.variant === 'products') {
                                const productCards = pageData.relatedProducts ? pageData.relatedProducts.map(product => ({
                                    id: product.id,
                                    title: product.displayName,
                                    description: product.teaser,
                                    image: product.listImage ? product.listImage.url : '',
                                    buttonText: "WHERE TO BUY",
                                    linkUrl: `/products/${product.slug}/`
                                })) : [];
                                
                                return (
                                    <CardDeck 
                                        key={`component-${index}`}
                                        variant={componentData.variant} 
                                        data={{
                                            id: 'industrial-products',
                                            eyebrow: "INDUSTRIAL-GRADE PRODUCTS",
                                            cards: productCards
                                        }}
                                        themeColor={pageSpecificData.themeColor}
                                        pageSlug={pageSlug}
                                    />
                                );
                            } else {
                                return (
                                    <CardDeck
                                        key={`component-${index}`}
                                        variant={componentData.variant}
                                        data={{
                                            id: componentData.id,
                                            eyebrow: componentData.eyebrow,
                                            title: componentData.title,
                                            subtitle: componentData.subtitle,
                                            body: componentData.body,
                                            cards: componentData.cards,
                                            extraImages: componentData.extraImages || [],
                                            ctaText: componentData.ctaText,
                                            ctaUrl: componentData.ctaUrl,
                                            ctaButton: componentData.ctaButton
                                        }}
                                        themeColor={pageSpecificData.themeColor}
                                        pageSlug={pageSlug}
                                        {...componentData}
                                    />
                                );
                            }
                        case 'fullWidthCTA':
                            return (
                                <FullWidthCTA 
                                    key={`component-${index}`}
                                    title={componentData.title}
                                    buttons={componentData.buttons}
                                />
                            );
                        case 'NumberedStepsList':
                            return (
                                <NumberedStepsList
                                    key={`component-${index}`}
                                    data={componentData}
                                />
                            );
                        case 'video':
                            return (
                                <VideoSection
                                    key={`component-${index}`}
                                    id={componentData.id}
                                    title={componentData.title}
                                    body={componentData.body}
                                    videoUrl={componentData.videoUrl}
                                    thumbnailImage={componentData.thumbnailImage}
                                />
                            );
                        case 'success-stories':
                            return pageData.relatedPressReleases && pageData.relatedPressReleases.length > 0 ? (
                                <CardDeck
                                    key={`component-${index}`}
                                    variant="success-stories"
                                    data={{
                                        id: "success-stories",
                                        title: "INDUSTRIAL SUCCESS STORIES",
                                        eyebrow: componentData.eyebrow,
                                        cards: pageData.relatedPressReleases.slice(0, 2).map(press => ({
                                            id: press.id,
                                            image: press.heroImage && press.heroImage.url ? press.heroImage.url : '',
                                            title: press.title,
                                            date: new Date(press.dateOfArticle).toLocaleDateString('en-US', {
                                                year: 'numeric',
                                                month: 'long',
                                                day: 'numeric'
                                            }),
                                            excerpt: press.teaser && press.teaser.length > 300 ? press.teaser.substring(0, 297) + '...' : press.teaser,
                                            linkText: "READ MORE",
                                            linkUrl: `/article/${press.slug}`
                                        }))
                                    }}
                                />
                            ) : null;
                        case 'related-articles':
                        case 'insights':
                            return pageData.relatedArticles && pageData.relatedArticles.length > 0 ? (
                                <CardDeck 
                                    key={`component-${index}`}
                                    variant="insights"
                                    isCarousel={true}
                                    data={{
                                        id: "industrial-insights",
                                        title: "INDUSTRIAL INSIGHTS",
                                        eyebrow: componentData.eyebrow,
                                        cards: pageData.relatedArticles.map(article => ({
                                            id: article.slug,
                                            image: article.heroImage && article.heroImage.url ? article.heroImage.url : '',
                                            title: article.title,
                                            date: new Date(article.dateOfArticle).toLocaleDateString('en-US', {
                                                year: 'numeric',
                                                month: 'long',
                                                day: 'numeric'
                                            }),
                                            excerpt: article.teaser && article.teaser.length > 300 ? article.teaser.substring(0, 297) + '...' : article.teaser,
                                            linkText: "READ MORE",
                                            linkUrl: `/article/${article.slug}`
                                        }))
                                    }}
                                />
                            ) : null;
                        case 'site-assessment-form':
                            return (
                                <SiteAssessmentForm 
                                    key={`component-${index}`}
                                />
                            );
                        default:
                            return null;
                    }
                })}

            </div>
        </NewLayout>
    );
};

export default IndustrialPageNew;
